import { render, staticRenderFns } from "./error-message.html?vue&type=template&id=0fd47fce&scoped=true&"
import script from "./error-message.js?vue&type=script&lang=js&"
export * from "./error-message.js?vue&type=script&lang=js&"
import style0 from "./error-message.scss?vue&type=style&index=0&id=0fd47fce&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd47fce",
  null
  
)

export default component.exports